import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=38f623ba&scoped=true&"
import script from "./ContactPage.vue?vue&type=script&lang=ts&"
export * from "./ContactPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=38f623ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f623ba",
  null
  
)

export default component.exports